.host {
  font-size: 1rem;
}
